/*
 * Refreshes, on page load, the duration of ONGOING career entries (missions /
 * contracts / roles with no end date), which the static generation (SSG) freezes
 * at the build date. Finished entries keep their static duration, which is final
 * and correct. Progressive enhancement: without JS, the build value already present
 * in the HTML stays displayed (only the ongoing ones may then drift over time).
 *
 * INVARIANT: this duplicates the Java algorithm in
 * fr.yadoc.site.web.extension.DateExtensions#formatDuration, for the single
 * "start -> today" case (ongoing entries) only. Any change to the duration logic
 * MUST be mirrored there; the reference cases live in DateExtensionsTest. The
 * inclusive-end rule (end.plusDays(1)) is NOT reproduced here: it applies only to
 * finished entries, which are never touched.
 *
 * Ongoing entries are marked in mission-card.html with a [data-duration-start]
 * span (ISO start date) wrapping the build-time fallback value.
 */
function durationFromStart(startISO) {
	const parts = String(startISO).slice(0, 10).split('-');
	const sy = Number(parts[0]), sm = Number(parts[1]), sd = Number(parts[2]);
	if (!sy || !sm || !sd) return '';
	const now = new Date();
	let years = now.getFullYear() - sy;
	let months = now.getMonth() + 1 - sm;
	if (now.getDate() < sd) months -= 1;
	if (months < 0) {
		years -= 1;
		months += 12;
	}
	if (years === 0) {
		if (months <= 0) return 'just started';
		return months === 1 ? '1 mois' : months + ' mois';
	}
	if (years === 1) return months > 0 ? '1 an ' + months + ' mois' : '1 an';
	return months > 0 ? years + ' ans ' + months + ' mois' : years + ' ans';
}

function refreshOngoingDurations() {
	document.querySelectorAll('[data-duration-start]').forEach(function (el) {
		const value = durationFromStart(el.getAttribute('data-duration-start'));
		if (value) el.textContent = value;
	});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', refreshOngoingDurations);
} else {
	refreshOngoingDurations();
}
